import { useCallback, useContext, useRef, useState } from "react";
import styles from './TableUploadRow.module.scss';
import { Field, useField, useForm } from "react-final-form";
import { alignmentType, UnderwritingFormStatus, UnderwritingSteps, uploadStates } from "../../../../interfaces/interfaces";
import { UnderwritingFormContext } from "../../context/UnderwritingFormContext";
import { TableFormBody, TableFormRow } from "./TableForm";
import TableUpload from "./TableUploadCell";
import PdfPasswordProtection from "../MultiFileUploadModal/PdfPasswordProtection";
import { getIn } from "final-form";
import MeritoButton from "../../../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineFileUpload as FileUploadIcon } from 'react-icons/md';
import MultiFileUploadModal from "../MultiFileUploadModal/MultiFileUploadModal";
import { RiCheckboxCircleFill as SuccessIcon } from 'react-icons/ri'

type Props = {
  isLast: boolean;
  stepName: UnderwritingSteps;
  documentType: string;
  fieldItem: {
    title: string;
    subTitle?: string;
    key: string;
    isMultiFile: boolean;
    [x: string]: any;
  };
  formCompleteStatus: {
    [x: string]: UnderwritingFormStatus;
  };
  newUploadedDocIds: number[];
  setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  deleteDocIds: number[],
  setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  fieldName: string;
  formContext?: any;
  colWidths?: string[];
}

const TableUploadRow = ({ stepName, fieldItem, isLast, formCompleteStatus, deleteDocIds, setDeleteDocIds, newUploadedDocIds, setNewUploadedDocIds, documentType, fieldName, formContext = null, colWidths = [] }: Props) => {
  const { underwritingFileJobs, sendFileJobToApi } = useContext(formContext ? formContext : UnderwritingFormContext) as any;
  const { getState } = useForm();


  const [isMultiFileUploadOpen, setIsMultiFileUploadOpen] = useState(false);
  const getJobDetails = useCallback((fieldName) => {
    const jobDetails = underwritingFileJobs?.[stepName]?.[fieldName] ?? null;
    // console.log('jobDetails', jobDetails);
    return jobDetails;
  }, [underwritingFileJobs]);
  const [showPasswordSuccess, setShowPasswordSuccess] = useState(false);

  const handlePasswordSubmit = (password: string, fieldName: string) => {
    setShowPasswordSuccess(true);
    // console.log('form fieldName', fieldName);
    // console.log('fieldName params', fieldNameParams)
    // console.log('jobDetails', underwritingFileJobs);
    const fileJobDetails = getJobDetails(fieldName);

    console.log('file JOb details', fileJobDetails);
    sendFileJobToApi(stepName, fieldName, {
      ...fileJobDetails,
      fileMetaData: {
        ...fileJobDetails.fileMetaData,
        password: password,
      },
      status: uploadStates.doneUploading,
    });
  }

  // console.log('fieldName', fieldName)

  const uploadedData = getIn(getState()?.values, fieldName);

  const showPasswordComponent = (getJobDetails(`${fieldName}`)?.status == uploadStates.requiredPassword || showPasswordSuccess) && uploadedData?.uploadedFile;
  const fileInputRef = useRef<HTMLInputElement>(null);

  const validateMultipleFiles = (values, underwritingFileJobs) => {
    if (!values || !values.length) {
      return `Upload Document`
    } else {
      const allUploadedJobs = getIn(underwritingFileJobs, stepName);
      // console.log('allUploadedJobs', allUploadedJobs)
      if (values?.length) {
        const passwordRequired = values.some((auditedFinancial, index) => {
          const uploadedFileJob = allUploadedJobs[`${fieldName}.files[${index}]`];
          // console.log('uploadedFileJob', uploadedFileJob)
          if (uploadedFileJob?.status == uploadStates?.requiredPassword) {
            return true;
          }
        });
        if (passwordRequired) {
          return 'Password missing';
        }
      }
    }
  }

  const multiFileUpload = getIn(getState()?.values, `${fieldName}.files`);


  const isColWidthsPresent = colWidths?.length > 0;

  return (
    <>
      <TableFormRow id={`${fieldName}.selectedFile`} hideBorder={isLast ? true : showPasswordComponent ? true : false}>
        <TableFormBody styles={{
          paddingBottom: showPasswordComponent ? '0' : '0.5rem',
          width: isColWidthsPresent ? colWidths[0] : 'auto',
        }} alignment={alignmentType.leftAlign}>
          <div className={styles.docTitleContainer}>
            <div className={styles.title}>
              {fieldItem?.title}
            </div>
            {fieldItem?.subTitle ? <div className={styles.subTitle}>
              {fieldItem?.subTitle}
            </div> : null}
          </div>
        </TableFormBody>
        <TableFormBody styles={{
          paddingBottom: showPasswordComponent ? '0' : '0.5rem',
          width: isColWidthsPresent ? colWidths[1] : 'auto',
        }} alignment={alignmentType.centerAlign}>
          {fieldItem?.isMultiFile ?
            <div className={styles.uploadBtnContainer}>
              {multiFileUpload?.length ?
                <div className={styles.fileUploadedContainer}>
                  <div className={styles.iconContainer}>
                    <SuccessIcon />
                  </div>
                  <div className={styles.successText}>
                    {`${multiFileUpload?.length} ${multiFileUpload?.length > 1 ? 'files' : 'file'} uploaded`}
                  </div>
                </div> : null}
              <MeritoButton
                type='tertiary'
                icon={<FileUploadIcon />}
                onlyIcon={true}
                onClick={() => {
                  setIsMultiFileUploadOpen(true)
                }}
              />
              <Field validate={(values) => {
                const error = validateMultipleFiles(values, underwritingFileJobs);
                return error;
              }} name={`${fieldName}.files`}>
                {props => {
                  // console.log('props', props)
                  return <>
                    {props?.meta?.error && props?.meta?.touched ? <div className={styles.errorContainer}>
                      {props?.meta?.error}
                    </div> : null}
                  </>
                }}
              </Field>

              <MultiFileUploadModal
                fieldName={`${fieldName}.files`}
                isOpen={isMultiFileUploadOpen}
                setIsOpen={setIsMultiFileUploadOpen}
                title={fieldItem?.multiFileDetails?.title}
                subtitle={fieldItem?.multiFileDetails?.subTitle}
                stepType={stepName}
                uploadSectionType={'financials'}
                newUploadedDocIds={newUploadedDocIds}
                setNewUploadedDocIds={setNewUploadedDocIds}
                deleteDocIds={deleteDocIds}
                setDeleteDocIds={setDeleteDocIds}
              />
            </div>
            :
            <TableUpload
              documentType={documentType}
              showUploadIcon={true}
              fieldName={`${fieldName}`}
              formCompleteStatus={formCompleteStatus}
              stepName={stepName}
              isMultiFileUpload={fieldItem.isMultiFile}
              deleteDocIds={deleteDocIds}
              setDeleteDocIds={setDeleteDocIds}
              newUploadedDocIds={newUploadedDocIds}
              setNewUploadedDocIds={setNewUploadedDocIds}
              setPasswordSuccess={setShowPasswordSuccess}
              formContext={formContext}
            />}
        </TableFormBody>
      </TableFormRow>
      {showPasswordComponent ?
        <TableFormRow hideBorder={isLast ? true : false}>
          <Field validate={(values) => {
            // console.log('password values', values)
            if (getJobDetails(`${fieldName}`)?.status == uploadStates.requiredPassword && values) {
              return 'Required Password';
            }
          }} name={`${fieldName}.uploadedFile`}>
            {props => {
              return (
                <TableFormBody innerDivStyles={{
                  display: "block",
                }} colSpan={2} alignment={alignmentType.leftAlign}>
                  <PdfPasswordProtection showPasswordSuccess={showPasswordSuccess} fileDetails={uploadedData} handleSubmitPassword={(password) => handlePasswordSubmit(password, fieldName)} />
                </TableFormBody>
              )
            }}
          </Field>
        </TableFormRow>
        : null}
    </>
  );
}

export default TableUploadRow;